export default __webpack_public_path__ + "static/media/1269.eef1e47f.png";